import React from 'react';
import New from '../components/Blogs/new/new';

const News = () => {
  return (
    <>
      <New />
    </>
  );
};

export default News;
